module.exports = __webpack_public_path__ + "img/direct-download.8f5933a4.svg";